import React, { useState } from "react";
import copy from "../assets/svg/copy.svg";
import Image from "@vfuk/core-image";
import { useTranslation } from "react-i18next";
import styled from "styled-components";

export interface CopyButtonProps {
  onClick?: () => void;
}

const StyledContainer = styled.div<{ activated: boolean }>`
  padding-left: 10px;
  padding-right: 10px;
  opacity: ${(props) => (props.activated ? 0.5 : 1)};
`;

const CopyButton = ({ onClick }: CopyButtonProps) => {
  const { t } = useTranslation();
  const [activated, setActivated] = useState(false);

  const onClickHandler = () => {
    setActivated(true);
    onClick?.();
  };

  return (
    <StyledContainer activated={activated} onClick={onClickHandler}>
      <Image
        alt={t("core:common:pdf_placeholder")}
        sm={{
          src: copy,
        }}
      />
    </StyledContainer>
  );
};

export default CopyButton;
